import Navbar from '@/components/feature/Navbar';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import AboutSection from './components/AboutSection';
import ArticleSection from './components/ArticleSection';
import FeatureSection from './components/FeatureSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL;

const organizationJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'pandabuy.monster',
  url: siteUrl,
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/2ce33a4b04813007a8211abaa8144b8a.jpeg',
  description:
    'Discover the best pandabuy spreadsheet finds in 2026. Explore curated sneaker, streetwear, luxury fashion, and essential spreadsheets updated weekly with budget-friendly picks, quality ratings, and comparisons.',
  sameAs: [
    'https://kaspreadsheet.com',
  ],
};

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'pandabuy.monster',
  url: siteUrl,
  description:
    'Discover the best pandabuy spreadsheet finds in 2026. Explore curated sneaker, streetwear, luxury fashion, and essential spreadsheets updated weekly with budget-friendly picks, quality ratings, and comparisons.',
  inLanguage: 'en',
};

export default function Home() {
  return (
    <main>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <Navbar />
      <HeroSection />
      <CategorySection />
      <AboutSection />
      <ArticleSection />
      <FeatureSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </main>
  );
}